import React, { useEffect, useState } from 'react';
import { api } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Send, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Banner displayed at the top of the Dashboard for admins when today's
 * opportunity emails have NOT been sent past 09:00 Paris.
 * Auto-hides if everything is fine.
 */
export default function MorningEmailsAlertBanner() {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get('/admin/morning-emails-status');
      setStatus(data);
    } catch { /* silent */ }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 5 * 60 * 1000); // refresh every 5 min
    return () => clearInterval(t);
  }, []);

  const resendNow = async () => {
    setResending(true);
    try {
      const { data } = await api.post('/opportunities/resend-today');
      toast.success(`${data.sent || 0} emails du jour renvoyés`);
      setTimeout(load, 1500);
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); }
    setResending(false);
  };

  if (!status || !status.should_alert || dismissed) return null;

  return (
    <div className="relative bg-gradient-to-r from-[#7F1D1D] to-[#B91C1C] text-white rounded-xl p-4 shadow-lg mb-4"
      data-testid="morning-emails-alert-banner">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5 animate-pulse" />
        <div className="flex-1">
          <p className="font-bold text-sm">
            Les emails d'opportunités du matin ne sont pas partis aujourd'hui
          </p>
          <p className="text-xs text-[#FCA5A5] mt-1">
            {status.today_opportunities_created} opportunités créées · {status.today_emails_sent} emails envoyés.
            Vérifiez la configuration Resend (clé / domaine) ou cliquez ci-dessous pour relancer.
          </p>
          <div className="flex gap-2 mt-3">
            <Button size="sm" onClick={resendNow} disabled={resending}
              className="bg-white text-[#B91C1C] hover:bg-[#FEE2E2] h-8"
              data-testid="resend-morning-emails-btn">
              {resending ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Send className="w-3.5 h-3.5 mr-1" />}
              Renvoyer les emails du jour
            </Button>
          </div>
        </div>
        <button onClick={() => setDismissed(true)} className="text-white/70 hover:text-white"
          data-testid="dismiss-morning-alert">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
